export default __webpack_public_path__ + "static/media/EVCharge_Logo.7681fcaf.png";